var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_116_825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9998 2.1665C7.01984 2.1665 2.1665 7.01984 2.1665 12.9998C2.1665 18.9798 7.01984 23.8332 12.9998 23.8332C18.9798 23.8332 23.8332 18.9798 23.8332 12.9998C23.8332 7.01984 18.9798 2.1665 12.9998 2.1665ZM7.96234 20.0415C9.3815 19.0232 11.1148 18.4165 12.9998 18.4165C14.8848 18.4165 16.6182 19.0232 18.0373 20.0415C16.6182 21.0598 14.8848 21.6665 12.9998 21.6665C11.1148 21.6665 9.3815 21.0598 7.96234 20.0415ZM19.6515 18.5465C17.8207 17.1165 15.5132 16.2498 12.9998 16.2498C10.4865 16.2498 8.179 17.1165 6.34817 18.5465C5.0915 17.0407 4.33317 15.1123 4.33317 12.9998C4.33317 8.2115 8.2115 4.33317 12.9998 4.33317C17.7882 4.33317 21.6665 8.2115 21.6665 12.9998C21.6665 15.1123 20.9082 17.0407 19.6515 18.5465Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9996 6.49982C10.9087 6.49982 9.20789 8.20065 9.20789 10.2915C9.20789 12.3823 10.9087 14.0832 12.9996 14.0832C15.0904 14.0832 16.7912 12.3823 16.7912 10.2915C16.7912 8.20065 15.0904 6.49982 12.9996 6.49982ZM12.9996 11.9165C12.1004 11.9165 11.3746 11.1907 11.3746 10.2915C11.3746 9.39232 12.1004 8.66648 12.9996 8.66648C13.8987 8.66648 14.6246 9.39232 14.6246 10.2915C14.6246 11.1907 13.8987 11.9165 12.9996 11.9165Z",
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.d259f8b417c40bb3875f02ce0b40e8c2.svg";
export { ForwardRef as ReactComponent };